import React from 'react'

function Services() {
  return (
    <main id="primary" className="site-main">
      <div className="space-for-header"></div>
      {/* start: Breadcrumb Section */}
      <section className="tj-page-header section-gap-x" data-bg-image="assets/images/bg/pheader-bg.webp">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="tj-page-header-content text-center">
                <h1 className="tj-page-title">Our Products</h1>
                <div className="tj-page-link">
                  <span><i className="fa-solid fa-home"></i></span>
                  <span>
                    <a href="/">Home</a>
                  </span>
                  <span><i className="fa-solid fa-arrow-right"></i></span>
                  <span>
                    <span>Our Products</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="page-header-overlay" data-bg-image="assets/images/shape/pheader-overlay.png"></div>
      </section>
      {/* end: Breadcrumb Section */}

      {/* start: Service Section */}
      <section className="tj-service-section service-4 section-gap">
        <div className="container">
          <div className="row row-gap-4">
            <div className="col-lg-4 col-md-6">
              <div className="service-item style-4 wow fadeInUp" data-wow-delay=".1s">
                  <img src='/assets/images/SD PHRMA BG JPGS/4.png' alt='Tablet Making Machine' />
                <div className="service-content">
                  <h4 className="title"><a href="/high-speed-double-side-rotary-tablet-press">HIGH SPEED DOUBLE SIDE ROTARY TABLET PRESS</a></h4>
                  {/* <p className="desc">Advanced tablet making machines designed for pharmaceutical production with high precision and efficiency.</p> */}
                  <a className="text-btn" href="/high-speed-double-side-rotary-tablet-press">
                    <span className="btn-text"><span>Learn More</span></span>
                    <span className="btn-icon"><i className="tji-arrow-right-long"></i></span>
                  </a>
                </div>
              </div>
            </div>
            
            <div className="col-lg-4 col-md-6">
              <div className="service-item style-4 wow fadeInUp" data-wow-delay=".3s">
                  <img src='/assets/images/SD PHRMA BG JPGS/8.png' alt='Roll Compactor' />
                <div className="service-content">
                  <h4 className="title"><a href="/double-side-rotary-tableting-machine">Double Side Rotary Tableting Machine</a></h4>
                  <a className="text-btn" href="/double-side-rotary-tableting-machine">
                    <span className="btn-text"><span>Learn More</span></span>
                    <span className="btn-icon"><i className="tji-arrow-right-long"></i></span>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="service-item style-4 wow fadeInUp" data-wow-delay=".5s">
                <img src='/assets/images/SD PHRMA BG JPGS/10.png' alt='Tablet Press Machine' />
                <div className="service-content">
                  <h4 className="title"><a href="/single-rotary-tablet-press">Single Side Rotary Tablet Press (GMP)</a></h4>
                  <a className="text-btn" href="/single-rotary-tablet-press">
                    <span className="btn-text"><span>Learn More</span></span>
                    <span className="btn-icon"><i className="tji-arrow-right-long"></i></span>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="service-item style-4 wow fadeInUp" data-wow-delay=".5s">
                <img src='/assets/images/SD PHRMA BG JPGS/12.png' alt='Tablet Press Machine' />
                <div className="service-content">
                  <h4 className="title"><a href="/single-rotary-tablet-press-non-gmp">Single Side Rotary Tablet Press (NON GMP)</a></h4>
                  <a className="text-btn" href="/single-rotary-tablet-press-non-gmp">
                    <span className="btn-text"><span>Learn More</span></span>
                    <span className="btn-icon"><i className="tji-arrow-right-long"></i></span>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="service-item style-4 wow fadeInUp" data-wow-delay=".5s">
                <img src='/assets/images/SD PHRMA BG JPGS/14.png' alt='Tablet Press Machine' />
                <div className="service-content">
                  <h4 className="title"><a href="/mini-rotary-tablet-press">Mini Rotary Tablet Press</a></h4>
                  <a className="text-btn" href="/mini-rotary-tablet-press">
                    <span className="btn-text"><span>Learn More</span></span>
                    <span className="btn-icon"><i className="tji-arrow-right-long"></i></span>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="service-item style-4 wow fadeInUp" data-wow-delay=".5s">
                <img src='/assets/images/SD PHRMA BG JPGS/2.png' alt='Tablet Press Machine' />
                <div className="service-content">
                  <h4 className="title"><a href="/fluid-bed-dryer">Fluid Bed Dryer (FBD)</a></h4>
                  <a className="text-btn" href="/fluid-bed-dryer">
                    <span className="btn-text"><span>Learn More</span></span>
                    <span className="btn-icon"><i className="tji-arrow-right-long"></i></span>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="service-item style-4 wow fadeInUp" data-wow-delay=".5s">
                <img src='/assets/images/SD PHRMA BG JPGS/16.png' alt='Tablet Press Machine' />
                <div className="service-content">
                  <h4 className="title"><a href="/rapid-mixer-granulator">Rapid Mixer Granulator (RMG)</a></h4>
                  <a className="text-btn" href="/rapid-mixer-granulator">
                    <span className="btn-text"><span>Learn More</span></span>
                    <span className="btn-icon"><i className="tji-arrow-right-long"></i></span>
                  </a>
                </div>
              </div>
            </div>
              <div className="col-lg-4 col-md-6">
              <div className="service-item style-4 wow fadeInUp" data-wow-delay=".5s">
                <img src='/assets/images/SD PHRMA BG JPGS/18.png' alt='Tablet Press Machine' />
                <div className="service-content">
                  <h4 className="title"><a href="/roll-compactor-machine">Roll Compactor Machine</a></h4>
                  <a className="text-btn" href="/roll-compactor-machine">
                    <span className="btn-text"><span>Learn More</span></span>
                    <span className="btn-icon"><i className="tji-arrow-right-long"></i></span>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="service-item style-4 wow fadeInUp" data-wow-delay=".5s">
                <img src='/assets/images/SD PHRMA BG JPGS/30.png' alt='Tablet Press Machine' />
                <div className="service-content">
                  <h4 className="title"><a href="/oscillating-granulator">Oscillating Granulator Machine</a></h4>
                  <a className="text-btn" href="/oscillating-granulator">
                    <span className="btn-text"><span>Learn More</span></span>
                    <span className="btn-icon"><i className="tji-arrow-right-long"></i></span>
                  </a>
                </div>
              </div>
            </div>
          
            <div className="col-lg-4 col-md-6">
              <div className="service-item style-4 wow fadeInUp" data-wow-delay=".5s">
                <img src='/assets/images/SD PHRMA BG JPGS/20.png' alt='Tablet Press Machine' />
                <div className="service-content">
                  <h4 className="title"><a href="/colloid-mill-machine">Colloid Mill Machine</a></h4>
                  <a className="text-btn" href="/colloid-mill-machine">
                    <span className="btn-text"><span>Learn More</span></span>
                    <span className="btn-icon"><i className="tji-arrow-right-long"></i></span>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="service-item style-4 wow fadeInUp" data-wow-delay=".5s">
                <img src='/assets/images/SD PHRMA BG JPGS/22.png' alt='Tablet Press Machine' />
                <div className="service-content">
                  <h4 className="title"><a href="/mass-mixer-machine">Mass Mixer Machine</a></h4>
                  <a className="text-btn" href="/mass-mixer-machine">
                    <span className="btn-text"><span>Learn More</span></span>
                    <span className="btn-icon"><i className="tji-arrow-right-long"></i></span>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="service-item style-4 wow fadeInUp" data-wow-delay=".5s">
                <img src='/assets/images/SD PHRMA BG JPGS/28.png' alt='Tablet Press Machine' />
                <div className="service-content">
                  <h4 className="title"><a href="/coating-machine">Coating Machine</a></h4>
                  <a className="text-btn" href="/coating-machine">
                    <span className="btn-text"><span>Learn More</span></span>
                    <span className="btn-icon"><i className="tji-arrow-right-long"></i></span>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="service-item style-4 wow fadeInUp" data-wow-delay=".5s">
                <img src='/assets/images/SD PHRMA BG JPGS/32.png' alt='Tablet Press Machine' />
                <div className="service-content">
                  <h4 className="title"><a href="/vibro-sifter-machine">High Speed Vibro Sifter Machine</a></h4>
                  <a className="text-btn" href="/vibro-sifter-machine">
                    <span className="btn-text"><span>Learn More</span></span>
                    <span className="btn-icon"><i className="tji-arrow-right-long"></i></span>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="service-item style-4 wow fadeInUp" data-wow-delay=".5s">
                <img src='/assets/images/SD PHRMA BG JPGS/34.png' alt='Tablet Press Machine' />
                <div className="service-content">
                  <h4 className="title"><a href="/multi-mill-machine">Multi Mill Machine</a></h4>
                  <a className="text-btn" href="/multi-mill-machine">
                    <span className="btn-text"><span>Learn More</span></span>
                    <span className="btn-icon"><i className="tji-arrow-right-long"></i></span>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="service-item style-4 wow fadeInUp" data-wow-delay=".5s">
                <img src='/assets/images/SD PHRMA BG JPGS/26.png' alt='Tablet Press Machine' />
                <div className="service-content">
                  <h4 className="title"><a href="/de-burring-de-dusting-machine">De-Burring & De-Dusting Machine</a></h4>
                  <a className="text-btn" href="/de-burring-de-dusting-machine">
                    <span className="btn-text"><span>Learn More</span></span>
                    <span className="btn-icon"><i className="tji-arrow-right-long"></i></span>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="service-item style-4 wow fadeInUp" data-wow-delay=".5s">
                <img src='/assets/images/SD PHRMA BG JPGS/36.png' alt='Tablet Press Machine' />
                <div className="service-content">
                  <h4 className="title"><a href="/dust-extractor-machine">Dust Extractor Machine</a></h4>
                  <a className="text-btn" href="/dust-extractor-machine">
                    <span className="btn-text"><span>Learn More</span></span>
                    <span className="btn-icon"><i className="tji-arrow-right-long"></i></span>
                  </a>
                </div>
              </div>
            </div>
           
          </div>
        </div>
      </section>
      {/* end: Service Section */}

      {/* start: Contact Section */}
      <section className="tj-contact-section section-gap section-gap-x">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="global-map wow fadeInUp" data-wow-delay=".3s">
                <div className="global-map-img">
                  <img src="assets/images/bg/map.svg" alt="Image" />
                  <div className="location-indicator loc-1">
                    <div className="location-tooltip">
                      <span>Manufacturing Unit:</span>
                      <p>Shed No.31, Raghav Industrial Park, B/h. Krish Arcade, Nr. Adani Circle, S.P. Ring Road, Ramol, Ahmedabad - 382449 (Gujarat)</p>
                      <a href="tel:9537503030">P: +91 95375 03030</a>
                      <a href="mailto:sdpharma795@gmail.com">M: sdpharma795@gmail.com</a>
                    </div>
                  </div>
                  <div className="location-indicator loc-2">
                    <div className="location-tooltip">
                      <span>Corporate Office:</span>
                      <p>Shed No.31, Raghav Industrial Park, B/h. Krish Arcade, Nr. Adani Circle, S.P. Ring Road, Ramol, Ahmedabad - 382449 (Gujarat)</p>
                      <a href="tel:9537503030">P: +91 95375 03030</a>
                      <a href="mailto:sdpharma795@gmail.com">M: sdpharma795@gmail.com</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="contact-form style-2 wow fadeInUp" data-wow-delay=".4s">
                <div className="sec-heading">
                  <span className="sub-title text-white"><i className="fa-solid fa-box"></i>Get in Touch</span>
                  <h2 className="sec-title title-anim">Drop Us a <span>Line.</span></h2>
                </div>
                <div id="contact-form-2">
                  <div className="row wow fadeInUp" data-wow-delay=".5s">
                    <div className="col-sm-6">
                      <div className="form-input">
                        <input type="text" name="cfName2" placeholder="Full Name *" />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-input">
                        <input type="email" name="cfEmail2" placeholder="Email Address *" />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-input">
                        <input type="tel" name="cfPhone2" placeholder="Phone number *" />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-input">
                        <div className="tj-nice-select-box">
                          <div className="tj-select">
                            <select name="cfSubject2">
                              <option value="0">Select Product Interest</option>
                              <option value="1">Tablet Press Machine</option>
                              <option value="2">Roll Compactor</option>
                              <option value="3">Tablet Coating Machine</option>
                              <option value="4">Rapid Mixer Granulator</option>
                              <option value="5">Fluid Bed Dryer</option>
                              <option value="6">Complete Production Line</option>
                              <option value="7">Other Equipment</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <div className="form-input message-input">
                        <textarea name="cfMessage2" id="message" placeholder="Type message *"></textarea>
                      </div>
                    </div>
                    <div className="submit-btn">
                      <button className="tj-primary-btn" type="button">
                        <span className="btn-text"><span>Send Message</span></span>
                        <span className="btn-icon"><i className="fa-solid fa-arrow-right"></i></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-shape-1">
          <img src="assets/images/shape/pattern-2.svg" alt="" />
        </div>
        <div className="bg-shape-2">
          <img src="assets/images/shape/pattern-3.svg" alt="" />
        </div>
      </section>
      {/* end: Contact Section */}

      {/* start: Client Section */}
      <section className="tj-client-section client-section-gap-2 wow fadeInUp" data-wow-delay=".4s">
        <div className="container-fluid client-container">
          <div className="row">
            <div className="col-12">
              <div className="client-content">
                <h5 className="sec-title">Trusted by <span className="client-numbers">500+</span> Pharmaceutical Companies with
                  <span className="client-text"> S.D. Pharma Machine</span>
                </h5>
              </div>
              <div className="swiper client-slider client-slider-1">
                <div className="swiper-wrapper">
                  <div className="swiper-slide client-item">
                    <div className="client-logo">
                      <img src="assets/images/brands/brand-1.webp" alt="" />
                    </div>
                  </div>
                  <div className="swiper-slide client-item">
                    <div className="client-logo">
                      <img src="assets/images/brands/brand-2.webp" alt="" />
                    </div>
                  </div>
                  <div className="swiper-slide client-item">
                    <div className="client-logo">
                      <img src="assets/images/brands/brand-3.webp" alt="" />
                    </div>
                  </div>
                  <div className="swiper-slide client-item">
                    <div className="client-logo">
                      <img src="assets/images/brands/brand-4.webp" alt="" />
                    </div>
                  </div>
                  <div className="swiper-slide client-item">
                    <div className="client-logo">
                      <img src="assets/images/brands/brand-5.webp" alt="" />
                    </div>
                  </div>
                  <div className="swiper-slide client-item">
                    <div className="client-logo">
                      <img src="assets/images/brands/brand-6.webp" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* end: Client Section */}

    </main>
  );
}

export default Services
